import React from 'react';

/**
 * Expose React in the global scope, so that React Dev Tools can find it
 *
 * Note: We don't use webpack's expose-loader to do this, because it is
 * [incompatible with DllPlugin][expose-loader-25].
 *
 * [expose-loader-25]: https://github.com/webpack-contrib/expose-loader/issues/25
 */
window.React = React;
